<template>
	<div>
		<Modal 
		:loading="loading" 
		:title="((this.current == 'new') ? 'NOVO VEÍCULO' : 'EDITAR VEÍCULO')"
		@close="close"
		@save="save">
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<small><b>Informações gerais</b></small>
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInputMasked v-model="license_plate" label="Placa" type="text" :required="true" mask="AAA#X##" tooltip="Informe a placa do veículo" ref="license_plate" />
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormSelect v-model="brand" label="Marca" :options="options.brand" :required="true" tooltip="Selecione a marca do veículo" ref="brand" />
				</div>
				<div class="col-xs-12 col-lg-4">
					<FormSelect v-model="vehicle_type" label="Tipo" :options="options.vehicle_type" :required="true" tooltip="Selecione o tipo do veículo" ref="vehicle_type" />
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormSelect v-model="bodywork" label="Carroceria" :options="options.bodywork" :required="true" tooltip="Selecione a correceria do veículo" ref="bodywork" />
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInput v-model="model" label="Modelo" type="text" tooltip="Selecione a modelo do veículo" ref="model" />
				</div>
            </div>

            <div class="row" style="padding-bottom: 25px;">
                <div class="col-xs-12 col-lg-12">
					<small><b>Capacidade</b></small>
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInputMasked v-model="weight_capacity" label="Peso" type="tel" :required="true" :mask="['# kg','## kg','### kg','#### kg','##### kg','###### kg','####### kg','######## kg','######### kg']" tooltip="Informe a capacidade de peso máxima que o veículo pode armazenar" ref="weight_capacity" />
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInputMasked v-model="volume_capacity" label="Volume" type="tel" :mask="['# m³','## m³','### m³','#### m³','##### m³','###### m³','####### m³','######## m³','######### m³']" tooltip="Informe a capacalidade de volume máximo que do veículo pode armazenar" ref="volume_capacity" />
				</div>
            </div>
            
            <div class="row">
                <div class="col-xs-12 col-lg-12">
					<small><b>Custos de Pedágio e Combustível</b></small>
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormSelect v-model="fuel_type" label="Combustível" :options="options.fuel_type" tooltip="Selecione o combustível do veículo" ref="fuel_type" />
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInputMasked v-model="average_speed" label="Velocidade Média" type="tel" :mask="['# km/h','## km/h','### km/h']" tooltip="Informe a velocidade média de tráfego do veículo (por padrão, foi definido 40 km/h)" ref="average_speed" />
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInputMasked  v-model="axles" label="Eixos" type="tel" :mask="['#']" tooltip="Informe a quantidade de eixos do veículo" ref="axles" />
				</div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-lg-12">
					<small><b>Regras</b></small>
				</div>
                <div class="col-xs-12 col-lg-4">
					<FormInputMasked v-model="minimum_occupancy" label="Ocupação Mínima" type="tel" :mask="['# %','## %','### %']" tooltip="Informe a ocupação mínima do que o veículo deve ter ao ser roteirizado" ref="minimum_occupancy" />
				</div>
                <div class="col-xs-12 col-lg-offset-3 col-lg-5">
					<FormCheckbox v-model="expanded_center" label="Centro Expandido (SP)" tooltip="Informe se o veículo tem permissão para circular no centro expandido de São Paulo" ref="expanded_center" />
				</div>
            </div>

            <div class="row" style="padding-bottom: 25px;">                
                <div class="col-xs-12 col-lg-12">
					<small><b>Detalhes</b></small>
				</div>
                <div class="col-xs-12 col-lg-5">
					<FormCheckbox v-model="return_origin" label="Retorna a origem?" icon="fa-undo-alt" tooltip="Informe se o veículo deve retorna ao centro de origen ao fim de seu roteiro" ref="return_origin" />
				</div>
                <div v-if="Object.keys(options_my_drivers).length > 0" class="col-xs-12 col-lg-12">
					<FormSelect v-model="fixed_driver" label="Motorista Fixo" :options="options_my_drivers" tooltip="Selecione o motorista que dirige o veículo de forma recorrente" ref="fixed_driver" />
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormCheckbox from "@/components/FormCheckbox";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";

export default {
	name: "VehicleForm",

	props: {
        current: {
            type: [String, Object],
            require: true,
        },
        my_drivers: {
            type: [Array, Object],
            require: true,
        },
    },

	components: {
        Modal,
        FormCheckbox,
        FormInput,
        FormInputMasked,
        FormSelect,
    },

	data: function() {
        if(this.current != 'new') {
			return {
                loading: false,
                
                // Geral
                id: this.current.id,
                license_plate: this.current.license_plate,
                brand: this.current.brand,
                vehicle_type: this.current.vehicle_type,
                bodywork: this.current.bodywork,
                model: this.current.model,
                // Capacidade
                weight_capacity: this.current.weight_capacity,
                volume_capacity: (this.current.volume_capacity == null) ? "" : this.current.volume_capacity,
                // Custos
                fuel_type: (this.current.fuel_type == null) ? "" : this.current.fuel_type,
                average_speed: (this.current.average_speed == null) ? "" : this.current.average_speed,
                axles: (this.current.axles == null) ? "" : this.current.axles + "",
                // Regras
                minimum_occupancy: (this.current.minimum_occupancy == null) ? "" : this.current.minimum_occupancy,
                expanded_center: (this.current.expanded_center == null) ? 0 : parseInt(this.current.expanded_center),
                // Detalhes
                return_origin: (this.current.return_origin == null) ? 0 : parseInt(this.current.return_origin),
                fixed_driver: (this.current.fk_driver == null) ? "" : this.current.fk_driver,

                options: this.getOptions()
			}
        }
        
		return {
            loading: false,
            
            // Geral
            id: '',
            license_plate: '',
            brand: '',
            vehicle_type: '',
            bodywork: '',
            model: '',
            // Capacidade
            weight_capacity: '',
            volume_capacity: '',
            // Custos
            fuel_type: '',
            average_speed: '',
            axles: '',
            // Regras
            minimum_occupancy: '',
            expanded_center: 0,
            // Detalhes
            return_origin: 1,
            fixed_driver: '',

            options: this.getOptions()
		}
	},

    computed: {
		options_my_drivers: function() {
			let r = {};
			this.my_drivers.map(v => {
				r[v.id] = v.name.toUpperCase() + " - " + v.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			});
			return r;
		}
	},

	methods: {
        // Retorna os options
        getOptions: function() {
            return {
                bodywork: {
                    'BAÚ': 'BAÚ',
                    'BAÚ FRIGORÍFICO': 'BAÚ FRIGORÍFICO',
                    'GRADE BAIXA': 'GRADE BAIXA',
                    'GRANELEIRA': 'GRANELEIRA',
                    'PLATAFORMA': 'PLATAFORMA',
                    'PORTA CONTAINER': 'PORTA CONTAINER',
                    'PRANCHA': 'PRANCHA',
                    'SIDER': 'SIDER',
                    'TANQUE': 'TANQUE',
                    'OUTRO': 'OUTRO',
                },
                brand: {
                    'AGRALE': 'AGRALE',
                    'BYD': 'BYD',
                    'DAF': 'DAF',
                    'EFFA (JBC/JMC)': 'EFFA (JBC/JMC)',
                    'FORD': 'FORD',
                    'FOTON': 'FOTON',
                    'HYUNDAI': 'HYUNDAI',
                    'INTERNATIONAL': 'INTERNATIONAL',
                    'IVECO': 'IVECO',
                    'JAC': 'JAC',
                    'MAN': 'MAN',
                    'MERCEDES-BENZ': 'MERCEDES-BENZ',
                    'PETERBILT': 'PETERBILT',
                    'SCANIA': 'SCANIA',
                    'SINOTRUCK': 'SINOTRUCK',
                    'SHACMAN': 'SHACMAN',
                    'VOLKSWAGEN': 'VOLKSWAGEN',
                    'VOLVO': 'VOLVO',
                    'OUTRO': 'OUTRO',
                },
                expanded_center: {
                    0: 'NÃO',
                    1: 'SIM'
                },
                fuel_type: {
                    'DIESEL': 'DIESEL',
                    'ETANOL': 'ETANOL',
                    'GASOLINA': 'GASOLINA',
                    'GNV': 'GNV',
                    'OUTRO': 'OUTRO',
                },
                vehicle_type: {
                    'CARRO': 'CARRO',
                    'CARRETA': 'CARRETA',
                    'MOTO': 'MOTO',
                    'TOCO': 'TOCO',
                    'TRUCK': 'TRUCK',
                    'UTILITÁRIO': 'UTILITÁRIO',
                    'VAN': 'VAN',
                    'VUC': 'VUC',
                    'OUTRO': 'OUTRO',
                }
            };
        },

        // Retorna messagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

        // Verifica e valida inicialmente os campos
		validation: function() {
            let data = {
                // Geral
                id: '',
                license_plate: '',
                brand: '',
                vehicle_type: '',
                bodywork: '',
                model: '',
                // Capacidade
                weight_capacity: '',
                volume_capacity: '',
                // Custos
                fuel_type: '',
                average_speed: '',
                axles: '',
                // Regras
                minimum_occupancy: '',
                expanded_center: 0,
                // Detalhes
                return_origin: 1,
                fixed_driver: ''
            };
            let error = false;
            
            // Id 
            data.id = this.id;

             // Placa
			if (this.license_plate == "") {
                this.$refs.license_plate.validate();
				this.$notification.error(this.message("PLACA"));
                error = true;
			} else {
				data.license_plate = this.license_plate.toUpperCase();
			}

            // Marca
			if (this.brand == "") {
                this.$refs.brand.trigger_blur();
				this.$notification.error(this.message("MARCA"));
                error = true;
			} else {
				data.brand = this.brand;
			}

			// Tipo do veículos
			if (this.vehicle_type == "") {
                this.$refs.vehicle_type.trigger_blur();
				this.$notification.error(this.message("TIPO"));
                error = true;
			} else {
				data.vehicle_type = this.vehicle_type;
			}
            
            // Carroceria
			if (this.bodywork == "") {
                this.$refs.bodywork.trigger_blur();
				this.$notification.error(this.message("CARROCERIA"));
                error = true;
			} else {
				data.bodywork = this.bodywork;
			}
            
            // Modelo
            data.model = this.model;
			
            // Capacidade de peso
			if (this.weight_capacity == "") {
                this.$refs.weight_capacity.validate();
				this.$notification.error(this.message("PESO"));
                error = true;
			} else {
				data.weight_capacity = this.weight_capacity;
			}
            
            data.volume_capacity = this.volume_capacity;
            
            // Tipo de combustível
            data.fuel_type = this.fuel_type;
            
            // Velocidade média
            data.average_speed = this.average_speed;
            
            // Eixos
            data.axles = this.axles;
            
            // Ocupação média
            data.minimum_occupancy = this.minimum_occupancy;
            
            // Centro expandido
            data.expanded_center = this.expanded_center;
            
            // Retorno a origem
            data.return_origin = this.return_origin;

            // Motorista fixo
            data.fixed_driver = this.fixed_driver;
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
        },

		// Envia para API e salva as informações no BD
        save: async function() {
            // Solicita a validação
			let form = this.validation();

            // Verifica o resultado da validação
			if(form == null) {
				return;
            }
            
            // Requisita o salvamento
			this.loading = true;
            let result = null;

            // Verifica se é edição
            if(this.id != "") {
                result = await Api.post("vehicle/edit", form);
            } else {
                result = await Api.post("vehicle/save", form);
            }
			this.loading = false;
            
            // Verifica o resultado da requisição
			if(result.error == true) {
                // Se tiver erro exibe as mensagens
				for(let i = 0; i < result.data.length; i++) {
					this.$notification.error(result.data[i]);
				}
			} else {
                // Senão houver exibe o sucesso
                // Verifica se é edição
                if(this.id != "") {
                    this.$notification.success("Veículo alterado com sucesso.");
                } else {
                    this.$notification.success("Veículo adicionado com sucesso.");
                }
                // Fecha o modal e recarrega a lista
				this.close();
				this.$parent.load();
			}
		},

		// Fecha o modal
		close: function() {
			this.$parent.current = false;
        }
	}
}
</script>

<style scoped>

</style>